<template>
  <div class="invoice_info">
    <el-divider content-position="left">开票信息表</el-divider>
    <el-row>
      <el-col :span="5">
        <span>公司名</span>
        <el-select v-model="searchArr.cid" clearable filterable remote @change="search" :size="inputSize"
          placeholder="请输入公司" :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="item in companies" :key="item.id" :label="item.company_name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="15">
        <div style="float: right;">
          <router-link to="bill">
            <el-button style="float: right;" type="primary" size="mini">添加申请</el-button>
          </router-link>
        </div>
        <!-- <el-button style="float: right;" type="primary" size="mini" @click="handleAddInvoiceInfo">添加申请</el-button> -->
        <!-- <router-link to="flag_chart" style="color: rgb(87, 135, 255);">数据看板</router-link> -->
      </el-col>
    </el-row>
    <el-table :data="invoics" size="mini" border style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column label="序号" fixed width="80">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="销方名称" fixed width="200">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" class="count-style">{{ scope.row.company ?
        scope.row.company.company_name : '' }}</el-link>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
              style="margin-left:0.1rem;cursor:pointer"
              @click="copySome(scope.row.company.company_name)"></i></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="buyer_name" label="购方名称" width="200" fixed>
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" class="count-style"
            @click="handelShowInfo(scope.$index, scope.row)">{{ scope.row.buyer_name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="发票类型" width="130">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.invoice_type ? scope.row.invoice_type : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.issue ? scope.row.status : '申请中' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invoice_tax" label="发票税号" width="160">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.invoice_tax }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="buyer_phone" label="购方电话" width="170">
        <template slot-scope="scope">
          <!-- <span class="hide-style">{{ scope.row.buyer_phone }}</span> -->
          <phone-com v-if="scope.row.buyer_phone" :comPhone="scope.row.buyer_phone"
            :vagaryPhone="scope.row.vagary_phone" style="display: inline-block" />
        </template>
      </el-table-column>
      <el-table-column prop="buyer_address" label="购方地址">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.buyer_address }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发布人员" width="100">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.admin ? scope.row.admin.username : (scope.row.user ? scope.row.user.name
        : '') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发布时间" width="140">
        <template slot-scope="scope">
          <!-- <span class="hide-style">{{ scope.row.created_at }}</span> -->
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column label="执行人员" width="100">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.exec_name }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="发票申请信息" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-edit"
              @click="handleApplyDetail(scope.$index, scope.row)" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="开票" placement="top">
            <el-button type="primary" size="mini" :disabled="scope.row.status === '完成开票'" icon="el-icon-document-copy"
              @click="handleAddInvoiceIssue(scope.$index, scope.row)" circle></el-button>
          </el-tooltip>
          <!-- <el-tooltip class="item"  effect="dark" content="商机-建议-续费" placement="top">
            <el-button type="success"  size="mini" icon="el-icon-document-add" @click="handleContinueOpen(scope.$index, scope.row)" circle></el-button>
          </el-tooltip> -->
          <!-- <el-tooltip class="item"  effect="dark" content="聊天记录" placement="top">
            <el-button type="primary" :disabled="scope.row.chat_com ? false : true" @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)" size="mini" icon="el-icon-s-comment" circle></el-button>
          </el-tooltip> -->
          <!--  <el-tooltip class="item"  effect="dark" content="企业微信群聊天记录" placement="top">
            <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)" size="mini" icon="el-icon-s-comment" circle></el-button>
          </el-tooltip> -->
          <!-- <el-tooltip class="item"  effect="dark" content="电话联系记录" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle @click="handCallLogsOpen(scope.row)"></el-button>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="tr mt-10" layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[5, 10, 20]"
      :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer title="开具发票" :visible.sync="issueDrawer" :before-close="handleInvoiceBeforeClose" size="35%">
      <div class="drawer-content">
        <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
          <el-row>
            <el-form-item label="开票状态" prop="status" width="100%">
              <el-select v-model="addForm.status" placeholder="请选择开具发票的状态" size="mini">
                <el-option label="正常开票" :value="2"></el-option>
                <el-option label="暂停开票" :value="3"></el-option>
                <el-option label="无需开票" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row v-if="addForm.status === 2">
            <el-form-item label="发票号段" prop="invoice_content">
              <el-input v-model="addForm.invoice_roughly" type="text" placeholder="请输入发票号段" />
            </el-form-item>
            <el-form-item label="开票张数" prop="invoice_content">
              <el-input v-model="addForm.invoice_num" type="number" placeholder="请输入开票张数" />
            </el-form-item>
            <el-form-item label="发票剩余张数" prop="invoice_content">
              <el-input v-model="addForm.invoice_remain" type="number" placeholder="请输入发票剩余张数" />
            </el-form-item>
            <el-form-item label="开票内容" prop="invoice_content">
              <el-input v-model="addForm.invoice_content" type="textarea" placeholder="请输入开票内容（若无 可不填写）" />
            </el-form-item>
            <el-form-item label="执行人备注" prop="exec_remark">
              <el-input v-model="addForm.exec_remark" type="textarea" placeholder="请输入需要告知客户的信息(若无 可不填写)" />
            </el-form-item>
            <el-card class="box-card">
              <el-row>
                <el-col :span="24">
                  <el-card shadow="hover">
                    <el-upload multiple ref="upload" action="#" :limit="5" :on-preview="handleLicensePreview"
                      :on-change="handleLicenseChange" :on-remove="handleLicenseRemove" :file-list="licenseList"
                      accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx" list-type="file"
                      :auto-upload="false">
                      <el-link slot="trigger" type="primary">上传开票截图或文件(最多可上传5个)</el-link>
                    </el-upload>
                  </el-card>
                </el-col>
              </el-row>
              <el-row class="mt-10">
                <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
              </el-row>
            </el-card>
          </el-row>
          <el-row v-else>
            <el-form-item label="操作原因" prop="stop_cause">
              <el-input v-model="addForm.stop_cause" type="textarea" placeholder="请输入暂停或不开具原因" />
            </el-form-item>
          </el-row>
        </el-form>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="开票申请信息" :visible.sync="applyDetailDrawer" :before-close="handleApplyDetailBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0 0 0 .4rem">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="top-line">销方基础信息</span>
          </div>
          <div>
            <el-row style='line-height: 56px;'>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="商户名称" placement="top">
                    <span class="count_style" style="display: inherit">名&emsp;&emsp;&emsp;&emsp;称：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="12" class="m-label">
                  <el-tooltip content="名称" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.company_name }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="纳税人识别号" placement="top">
                    <span class="count_style" style="display: inherit">纳税人识别号：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <el-tooltip content="纳税人识别号" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.taxNumber }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="地址、电话" placement="top">
                    <span class="count_style" style="display: inherit">地址、&emsp;电话：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <el-tooltip content="点击复制" placement="top">
                    <span class="count_style" style="display: inherit">
                      {{ (applyDetail.operate_address ? applyDetail.operate_address : '') + ' ' +
        (applyDetail.legaler_contact ? applyDetail.legaler_contact : '') }}
                    </span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开户行及账号" placement="top">
                    <span class="count_style" style="display: inherit">开户行及账号：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <span class="count_style" style="display: inherit">{{ applyDetail.bank_msg ? applyDetail.bank_msg :
        '' }}</span>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="8">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="收款人" placement="top">
                      <span class="count_style" style="display: inherit">收款人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span class="count_style" style="color: #409EFF; cursor: pointer; display: inherit">{{
        applyDetail.invoice_payee }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="复核人" placement="top">
                      <span class="count_style" style="display: inherit">复核人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span class="count_style" style="color: #409EFF; cursor: pointer; display: inherit">{{
        applyDetail.invoice_reviewer }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="开票人" placement="top">
                      <span class="count_style" style="display: inherit">开票人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span class="count_style" style="color: #409EFF; cursor: pointer; display: inherit">{{
        applyDetail.invoice_drawer }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="24" v-if="applyDetail.invoice_type == '增值税普通发票'">
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税普通发票" placement="top">
                      <span class="count_style" style="display: inherit">增值税普通发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_common === 1 ? '万元版' : (applyDetail.invoice_common === 2 ? '十万元版' : '百万元版')"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_common === 1 ? '万元版' :
        (applyDetail.invoice_common === 2 ? '十万元版' : (applyDetail.invoice_common === 3 ? '百万元版' : ''))
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税普通发票税率" placement="top">
                      <span class="count_style" style="display: inherit">增值税普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_common_rate ? (applyDetail.invoice_common_rate === 0 ? '免税' : applyDetail.invoice_common_rate + '%') : ''"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_common_rate ?
        (applyDetail.invoice_common_rate === 0 ? '免税' : applyDetail.invoice_common_rate + '%') : ''
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="24" v-if="applyDetail.invoice_type == '增值税电子普通发票'">
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税电子普通发票" placement="top">
                      <span class="count_style" style="display: inherit">增值税电子普通发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_ecommon === 1 ? '万元版' : (applyDetail.invoice_ecommon === 2 ? '十万元版' : '百万元版')"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_ecommon === 1 ? '万元版' :
        (applyDetail.invoice_ecommon === 2 ? '十万元版' : (applyDetail.invoice_ecommon === 3 ? '百万元版' : ''))
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税电子普通发票税率" placement="top">
                      <span class="count_style" style="display: inherit">增值税电子普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_ecommon_rate ? (applyDetail.invoice_ecommon_rate === 0 ? '免税' : applyDetail.invoice_ecommon_rate + '%') : ''"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_ecommon_rate ?
        (applyDetail.invoice_ecommon_rate === 0 ? '免税' : applyDetail.invoice_ecommon_rate + '%') : ''
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="24" v-if="applyDetail.invoice_type == '增值税专用发票'">
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税专用发票" placement="top">
                      <span class="count_style" style="display: inherit">增值税专用发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_special === 1 ? '万元版' : (applyDetail.invoice_special === 2 ? '十万元版' : '百万元版')"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_special === 1 ? '万元版' :
        (applyDetail.invoice_special === 2 ? '十万元版' : (applyDetail.invoice_special === 3 ? '百万元版' : ''))
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税普通发票税率" placement="top">
                      <span class="count_style" style="display: inherit">增值税普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_special_rate ? (applyDetail.invoice_special_rate === 0 ? '免税' : applyDetail.invoice_special_rate + '%') : ''"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_special_rate ?
        (applyDetail.invoice_special_rate === 0 ? '免税' : applyDetail.invoice_special_rate + '%') : ''
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="24" v-if="applyDetail.invoice_type == '增值税电子专用发票'">
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税电子专用发票" placement="top">
                      <span class="count_style" style="display: inherit">增值税电子专用发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_especial === 1 ? '万元版' : (applyDetail.invoice_especial === 2 ? '十万元版' : '百万元版')"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_especial === 1 ? '万元版' :
        (applyDetail.invoice_especial === 2 ? '十万元版' : (applyDetail.invoice_especial === 3 ? '百万元版' :
          ''))
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="9" class="m-label">
                    <el-tooltip content="增值税电子专用发票税率" placement="top">
                      <span class="count_style" style="display: inherit">增值税电子专用发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="15" class="m-label">
                    <el-tooltip
                      :content="applyDetail.invoice_especial_rate ? (applyDetail.invoice_especial_rate === 0 ? '免税' : applyDetail.invoice_especial_rate + '%') : ''"
                      placement="top">
                      <span class="count_style" style="display: inherit">{{ applyDetail.invoice_especial_rate ?
        (applyDetail.invoice_especial_rate === 0 ? '免税' : applyDetail.invoice_especial_rate + '%') : ''
                        }}</span>
                    </el-tooltip>
                  </el-col>
                </el-col>
              </el-col>

            </el-row>
          </div>
        </el-card>
        <el-card class="box-card" style="margin-top: .2rem;">
          <div slot="header" class="clearfix">
            <span class="top-line">购方信息</span>
          </div>
          <div>
            <el-row>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="购方名称" placement="top">
                    <span class="count_style" style="display: inherit">购方名称：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="12" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.buyer_name }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="发票税号" placement="top">
                    <span class="count_style" style="display: inherit">发票税号：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.invoice_tax }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="地址、电话" placement="top">
                    <span class="count_style" style="display: inherit">地址、&emsp;电话：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">
                      {{ (applyDetail.buyer_address ? applyDetail.buyer_address : '') + ' ' + (applyDetail.buyer_phone ?
        applyDetail.buyer_phone : '') }}
                    </span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开户行及账号" placement="top">
                    <span class="count_style" style="display: inherit">开户行及账号：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <span class="count_style" style="display: inherit">{{ applyDetail.invoice_bank + ' ' +
        applyDetail.invoice_account }}</span>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开具类型" placement="top">
                    <span class="count_style" style="display: inherit">开具类型：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.invoice_mode == 1 ? '普通开具' :
        '差额征收'
                      }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="是否含税" placement="top">
                    <span class="count_style" style="display: inherit">是否含税：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.is_tax_inclusive == 1 ? '含税' :
        '不含税'
                      }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="发票类型" placement="top">
                    <span class="count_style" style="display: inherit">发票类型：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.invoice_type }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开票金额" placement="top">
                    <span class="count_style" style="display: inherit">开票金额：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.invoice_amount }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="货物或应税劳务名称" placement="top">
                    <span class="count_style" style="display: inherit">货物或应税劳务名称：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.invoice_cate }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开票金额" placement="top">
                    <span class="count_style" style="display: inherit">执行人：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="8" class="m-label">
                  <el-tooltip content="" placement="top">
                    <span class="count_style" style="display: inherit">{{ applyDetail.exec_name }}</span>
                  </el-tooltip>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="4" class="m-label">
                  <el-tooltip content="发票明细" placement="top">
                    <span class="count_style" style="display: inherit">发票明细：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <span class="count_style" style="display: inherit">{{applyDetail.invoice_detail ?
                    applyDetail.invoice_detail : ''}}</span>
                </el-col>
              </el-col>
              <el-col>
                <el-row style="margin-bottom: 0; padding-bottom: 0;" v-if="applyDetail.create_img.length > 0">
                  <div class="demo-image__preview">
                    <el-divider content-position="left">图片资料</el-divider>
                    <div style="float: left;" v-for="(img, index) in applyDetail.create_img" :key="index">
                      <el-row style="margin: 0 0 0 0; padding: 0 0 0 0;">
                        <el-image style="width: 100px; height: 100px; padding: 0 5px 0 0" :src="img"
                          :preview-src-list="applyDetail.create_img">
                        </el-image>
                      </el-row>
                    </div>
                  </div>
                </el-row>
                <el-row v-if="applyDetail.create_file.length > 0">
                  <el-divider content-position="left">文件资料</el-divider>
                  <div v-for="(file, index) in applyDetail.create_file" :key="index">
                    <el-col :span="24" class="text-border">
                      <el-col :span="14" :offset="1">
                        <el-tooltip :content="file.file_name" placement="top">
                          <span class="count_style" style="display: inherit">{{ file.file_name }}</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="4"><el-button size="mini" type="success" plain
                          @click="downloadFile(file.file_path)">下载文件</el-button></el-col>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PhoneCom from "common/PhoneCom";
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'Invoice_info',
  components: { DateFormatter, PhoneCom },
  data() {
    return {

      searchArr: {
        cid: ''
      },
      inputSize: 'mini',
      loading: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10 // 每页显示条数
      },
      companies: [],
      invoics: [],
      formData: null,
      addForm: {
        index: null,
        info_id: null,
        status: 2,
        invoice_roughly: '',
        invoice_num: '',
        invoice_remain: '',
        invoice_content: '',
        exec_remark: '',
        stop_cause: ''
      },
      applyDetailDrawer: false,
      applyDetail: {
        invoice_type: '',
        company_name: '',
        operate_address: '',
        legaler_contact: '',
        taxNumber: '',
        invoice_payee: '',
        invoice_reviewer: '',
        invoice_drawer: '',
        invoice_common: null,
        invoice_common_rate: null,
        invoice_special: null,
        invoice_special_rate: null,
        invoice_ecommon: null,
        invoice_ecommon_rate: null,
        invoice_especial: null,
        invoice_especial_rate: null,
        invoice_mode: 1,
        is_tax_inclusive: null,
        invoice_cate: '',
        invoice_amount: null,
        invoice_bank: '',
        invoice_account: '',
        bank_msg: '', // 销方银行信息
        buyer_tax_num: '', // 发票税号
        buyer_address: '', // 地址
        buyer_phone: '', // 电话
        buyer_bank: '', // 开户行
        buyer_name: '', // 开户行
        buyer_bank_num: '', // 银行账号
        invoice_detail: '', // 发票明细
        invoice_remark: '', // 申请备注
        tax_plate_num: '', // 税盘编号
        file_location: '', // 档案位置
        exec_id: null,
        create_img: [],
        create_file: []
      },
      details: [],
      licenseList: [],
      infoDrawer: false,
      issueDrawer: false
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copySome(data) {
      this.copy(data)
    },
    search() {
      this.billingRecords()
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanies(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanies(query) {
      this.$axios.get('/api/admin/companies?company=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies.data
          }
        })
    },
    billingRecords() {
      this.$axios.get('/api/invoice_info?page=' + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.invoics = data.data.list.data
            this.pageOption.total = data.data.list.total
            this.pageOption.currentPage = data.data.list.current_page
          }
        })
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.billingRecords()
    },
    // 调整新增发票信息页面
    handleAddInvoiceInfo() {
      this.location = '/bill'
    },
    handleAddInvoiceIssue(index, row) {
      // 开票
      this.addForm.index = index
      this.addForm.info_id = row.id
      this.issueDrawer = true
    },
    handleLicensePreview(file) { },
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList
      this.formData = null
      this.formData = new FormData()
      this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key])
      }
    },
    handleParse(e) {
      let file = null
      if (e.clipboardData && e.clipboardData.items[0] && e.clipboardData.items[0].type && e.clipboardData.items[0].type.indexOf('image') > -1) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result
          }

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj)
          } else {
            that.$message.error('最多可以上传5张')
          }
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.addForm.status === 2) {
          if (!this.addForm.invoice_roughly) {
            this.$message.error('请输入发票号段')
          }
          if (!this.addForm.invoice_num) {
            this.$message.error('请输入开票张数')
          }
          if (!this.addForm.invoice_remain) {
            this.$message.error('请输入发票剩余张数')
          }
        } else {
          if (!this.addForm.stop_cause) {
            this.$message.error('请输入暂停开票或无需开票的原因')
          }
        }
        if (valid) {
          this.formData = new FormData()
          this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key])
          }
          this.$axios.post('/api/invoice_info/issue', this.formData)
            .then((res) => {
              let { data } = res
              if (data.code === 0) {
                this.invoics[this.addForm.index].status = data.data.info_detail.status
                this.invoics[this.addForm.index].issue = data.data.info_detail.issue
                this.invoics[this.addForm.index].issue_file = data.data.info_detail.issue_file
                this.invoics[this.addForm.index].issue_img = data.data.info_detail.issue_img
                this.issueDrawer = false
                this.clearAddForm()
                this.$refs['addForm'].resetFields()
                this.licenseList = []
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    clearAddForm() {
      this.addForm.index = null
      this.addForm.info_id = null
      this.addForm.status = 2
      this.addForm.invoice_roughly = ''
      this.addForm.invoice_num = ''
      this.addForm.invoice_remain = ''
      this.addForm.invoice_content = ''
      this.addForm.exec_remark = ''
      this.addForm.stop_cause = ''
    },
    handleAddClose(done) {
      this.$refs['addForm'].resetFields()
      this.licenseList = []
      this.formData = null
      done()
    },
    downloadFile(url) {
      window.open(url)
    },
    handleApplyDetail(index, row) {
      if (row.company) {
        this.applyDetail.company_name = row.company.company_name
        this.applyDetail.operate_address = row.company.operate_address
        this.applyDetail.legaler_contact = row.company.legaler_contact
        this.applyDetail.taxNumber = row.company.taxNumber
        this.applyDetail.invoice_payee = row.company.invoice_payee
        this.applyDetail.invoice_reviewer = row.company.invoice_reviewer
        this.applyDetail.invoice_drawer = row.company.invoice_drawer
        this.applyDetail.invoice_common = row.company.invoice_common
        this.applyDetail.invoice_common_rate = row.company.invoice_common_rate
        this.applyDetail.invoice_special = row.company.invoice_special
        this.applyDetail.invoice_special_rate = row.company.invoice_special_rate
        this.applyDetail.invoice_ecommon = row.company.invoice_ecommon
        this.applyDetail.invoice_ecommon_rate = row.company.invoice_ecommon_rate
        this.applyDetail.invoice_especial = row.company.invoice_especial
        this.applyDetail.invoice_especial_rate = row.company.invoice_especial_rate
      }
      this.applyDetail.buyer_name = row.buyer_name
      this.applyDetail.invoice_mode = row.invoice_mode
      this.applyDetail.invoice_type = row.invoice_type
      this.applyDetail.is_tax_inclusive = row.is_tax_inclusive
      this.applyDetail.invoice_cate = row.invoice_cate
      this.applyDetail.invoice_amount = row.invoice_amount
      this.applyDetail.invoice_tax = row.invoice_tax
      this.applyDetail.invoice_payee = row.invoice_payee // 收款人
      this.applyDetail.invoice_reviewer = row.invoice_reviewer // 复核人
      this.applyDetail.invoice_drawer = row.invoice_drawer // 开票人
      this.applyDetail.bank_msg = row.banks.bank + ' ' + row.banks.accnumber // 销方银行信息
      this.applyDetail.buyer_tax_num = row.buyer_tax_num // 发票税号
      this.applyDetail.buyer_address = row.buyer_address // 地址
      this.applyDetail.buyer_phone = row.buyer_phone // 电话
      this.applyDetail.buyer_bank = row.buyer_bank // 开户行
      this.applyDetail.buyer_bank_num = row.buyer_bank_num // 银行账号
      this.applyDetail.invoice_detail = row.invoice_detail // 发票明细
      this.applyDetail.invoice_remark = row.invoice_remark // 申请备注
      this.applyDetail.tax_plate_num = row.tax_plate_num // 税盘编号
      this.applyDetail.file_location = row.file_location // 档案位置
      this.applyDetail.exec_id = row.exec_id
      this.applyDetail.invoice_bank = row.invoice_bank
      this.applyDetail.invoice_account = row.invoice_account
      if (row.create_file) {
        this.applyDetail.create_file = row.create_file
      }
      if (row.create_img) {
        for (let key1 in row.create_img) {
          this.applyDetail.create_img.push(row.create_img[key1].file_path)
        }
      }
      this.applyDetailDrawer = true
    },
    clearApplyDetail() {
      this.applyDetailDrawer = false
      this.applyDetail.company_name = ''
      this.applyDetail.operate_address = ''
      this.applyDetail.legaler_contact = ''
      this.applyDetail.taxNumber = ''
      this.applyDetail.invoice_payee = ''
      this.applyDetail.invoice_reviewer = ''
      this.applyDetail.invoice_drawer = ''
      this.applyDetail.invoice_common = null
      this.applyDetail.invoice_common_rate = null
      this.applyDetail.invoice_special = null
      this.applyDetail.invoice_special_rate = null
      this.applyDetail.invoice_ecommon = null
      this.applyDetail.invoice_ecommon_rate = null
      this.applyDetail.invoice_especial = null
      this.applyDetail.invoice_especial_rate = null
    },
    handleApplyDetailBeforeClose(done) {
      this.clearApplyDetail()
      done()
    },
    handleInfoBeforeClose(done) {
      this.clearShow()
      done()
    },
    handleInvoiceBeforeClose(done) {
      this.clearAddForm()
      done()
    }
  },
  mounted() {
    this.billingRecords()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.reset-page-from
  display: inline-table
.reset-page-from span
  vertical-align: top
  display: inline-block
  font-size: .24rem
  height: .56rem
  line-height: .52rem
  padding: 0 .24rem
  color: #3a4c61
  border: 1px solid #dbdbdb
  border-right: 0
  box-sizing: border-box
  border-radius: .04rem 0 0 .04rem
  background: rgba(64,158,255,.1)
.invoice_info >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.drawer-content
  padding: 0 .4rem 0 .4rem
.invoice_info
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.search-row .el-col
  margin-bottom: .2rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
.col-tab
  border: .02rem solid #dbdbdb
  border-right: 0
.col-th
  font-size: .24rem
  color: #666
  padding: .24rem .16rem
  background-color: #f5f7fa
  border-right: 1px solid #e4e4e4
.col-td
  font-size: .24rem
  padding: .24rem .16rem
  border-right: .02rem solid #e4e4e4
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.count_style
  display: inherit
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.text-append
  display: flex
  font-size: .24rem
  height: .64rem
  line-height: .64rem
  border-left: .02rem solid #EBEEF5
  border-right: .02rem solid #EBEEF5
  border-bottom: .02rem solid #EBEEF5
  .text-append-p
    margin-left: .24rem
    margin-right: .24rem
    .text-append-span
      color: #ffaf57
      font-weight: 600
</style>



// WEBPACK FOOTER //
// src/pages/invoicing/Invoice_info.vue